import { withTranslations } from '@/utils/Language';
import statusIconEn from '@/assets/i18n/statusIcon/en.json';

const enDefault = { ...statusIconEn };

export default withTranslations(
  (lang) => Promise.all([import(`@/assets/i18n/statusIcon/${lang}.json`)]).then(([statusIcon]) => ({ ...statusIcon.default })),
  enDefault
);
